import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Audio Message
 */

export default function AudioMessageIcon(props) {
  return (
    <Icon viewBox="0 0 13 9" {...props}>
      <path
        clipRule="evenodd"
        d="M7 0.5C7 0.22386 6.77614 0 6.5 0C6.22386 0 6 0.22386 6 0.5V8.5C6 8.7761 6.22386 9 6.5 9C6.77614 9 7 8.7761 7 8.5V0.5ZM3 2C3 1.72386 2.77614 1.5 2.5 1.5C2.22386 1.5 2 1.72386 2 2V7C2 7.2761 2.22386 7.5 2.5 7.5C2.77614 7.5 3 7.2761 3 7V2ZM0.5 3.5C0.77614 3.5 1 3.72386 1 4V5C1 5.27614 0.77614 5.5 0.5 5.5C0.22386 5.5 0 5.27614 0 5V4C0 3.72386 0.22386 3.5 0.5 3.5ZM12.5 3.5C12.7761 3.5 13 3.72386 13 4V5C13 5.27614 12.7761 5.5 12.5 5.5C12.2239 5.5 12 5.27614 12 5V4C12 3.72386 12.2239 3.5 12.5 3.5ZM10.5 1.5C10.7761 1.5 11 1.72386 11 2V7C11 7.2761 10.7761 7.5 10.5 7.5C10.2239 7.5 10 7.2761 10 7V2C10 1.72386 10.2239 1.5 10.5 1.5ZM5 3C5 2.72386 4.77614 2.5 4.5 2.5C4.22386 2.5 4 2.72386 4 3V6C4 6.27614 4.22386 6.5 4.5 6.5C4.77614 6.5 5 6.27614 5 6V3ZM8.5 2.5C8.77614 2.5 9 2.72386 9 3V6C9 6.27614 8.77614 6.5 8.5 6.5C8.22386 6.5 8 6.27614 8 6V3C8 2.72386 8.22386 2.5 8.5 2.5Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
